import { CasinoTypeUnion, IGetFeedProviderResponse } from '../../../types';
import {
  normalizePlexMultiProviderResponse,
  normalizePlexProviders
} from '../../normalize';
import { GamesStorageType } from '../../types';

type PlexGetProvidersStatePreparator = (args: {
  state: GamesStorageType;
  data: IGetFeedProviderResponse[];
  casinoType: CasinoTypeUnion;
}) => GamesStorageType;

export const plexGetProvidersStatePreparator: PlexGetProvidersStatePreparator =
  ({ state, data, casinoType }) => {
    const normalizedData = normalizePlexMultiProviderResponse(data);
    const normalizedPlexProviders = normalizePlexProviders(normalizedData);
    return {
      ...state,
      lobbies: {
        ...state.lobbies,
        [casinoType]: {
          ...state.lobbies[casinoType],
          providersGames: normalizedPlexProviders.providersGames,
          providersTotalGames: normalizedPlexProviders.providersTotalGames,
          providersIds: normalizedPlexProviders.providersIds,
          isProvidersLoading: false,
          isProvidersLoaded: true
        }
      },
      providers: {
        ...state.providers,
        data: {
          ...state.providers.data,
          ...normalizedPlexProviders.providers
        },
        serviceIdToProviderId: {
          ...state.providers.serviceIdToProviderId,
          ...normalizedPlexProviders.serviceIdToProviderId
        }
      },
      games: {
        ...state.games,
        data: {
          ...state.games.data,
          ...normalizedPlexProviders.games
        },
        launchIdToGameId: {
          ...state.games.launchIdToGameId,
          ...normalizedPlexProviders.launchIdToGameId
        },
        ids: [
          ...new Set(
            Object.keys({
              ...state.games.data,
              ...normalizedPlexProviders.games
            })
          )
        ]
      }
    };
  };
